import React from 'react';
import { Box, Typography } from '@mui/material';

export interface CardMarketPriceDisplayProps {
  marketPrice: number;
  sellerPrice?: number;
  layout?: 'vertical' | 'horizontal';
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
}

const CardMarketPriceDisplay: React.FC<CardMarketPriceDisplayProps> = ({
  marketPrice,
  sellerPrice,
  layout = 'vertical',
  size = 'medium',
  showLabel = true,
}) => {
  const isDiscount = sellerPrice !== undefined && sellerPrice < marketPrice && marketPrice > 0;
  
  const priceSizes = {
    small: { title: '0.65rem', value: '0.8rem', old: '0.7rem' },
    medium: { title: '0.75rem', value: '1rem', old: '0.8rem' },
    large: { title: '0.85rem', value: '1.25rem', old: '0.9rem' },
  };

  const currentSize = priceSizes[size];

  if (sellerPrice !== undefined) {
    return (
      <Box sx={{ display: 'flex', flexDirection: layout === 'horizontal' ? 'row' : 'column', alignItems: layout === 'horizontal' ? 'baseline' : 'flex-start', gap: layout === 'horizontal' ? 1 : 0 }}>
        {showLabel && (
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: currentSize.title, display: 'block', mb: layout === 'horizontal' ? 0 : 0.5 }}>
            Price
          </Typography>
        )}
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold" color="primary" sx={{ fontSize: currentSize.value, lineHeight: 1 }}>
            ${sellerPrice.toFixed(2)}
          </Typography>
          {marketPrice > 0 && marketPrice !== sellerPrice && (
            <Typography 
              variant="caption" 
              color="text.secondary" 
              sx={{ 
                fontSize: currentSize.old, 
                textDecoration: 'line-through',
                opacity: 0.7 
              }}
            >
              ${marketPrice.toFixed(2)}
            </Typography>
          )}
        </Box>
        {isDiscount && (
          <Typography variant="caption" color="success.main" sx={{ fontSize: '0.65rem', fontWeight: 'bold', mt: 0.5 }}>
            {Math.round(((marketPrice - sellerPrice) / marketPrice) * 100)}% below market
          </Typography>
        )}
      </Box>
    );
  }

  // Just show Market Price
  return (
    <Box sx={{ display: 'flex', flexDirection: layout === 'horizontal' ? 'row' : 'column', alignItems: layout === 'horizontal' ? 'baseline' : 'flex-start', gap: layout === 'horizontal' ? 1 : 0 }}>
      {showLabel && (
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: currentSize.title, display: 'block', mb: layout === 'horizontal' ? 0 : 0.5 }}>
          Market Price
        </Typography>
      )}
      <Typography variant="subtitle1" fontWeight="bold" color="success.main" sx={{ fontSize: currentSize.value, lineHeight: 1 }}>
        ${marketPrice.toFixed(2)}
      </Typography>
    </Box>
  );
};

export default CardMarketPriceDisplay;
